'use strict';
(() => {
  const app = document.getElementById('lm-copy-app');
  if (!app) return;
  const cfg = JSON.parse(document.getElementById('lm-copy-data').textContent);
  const model = window.LMCopyModel, catalog = cfg.catalog, products = Object.values(catalog);
  const $ = id => document.getElementById(id);
  const params = new URLSearchParams(location.search);
  const money = cents => new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(cents / 100);
  const storageKey = 'lm-shopify-crew-v1';
  const commerce = window.LMShopifyCart.create({rootUrl:cfg.rootUrl, catalog, offers:cfg.offers});
  let serverCart = null, cartBusy = false;
  const families = [...new Set(products.map(product => product.family))];
  const hasPolicy = key => Object.prototype.hasOwnProperty.call(cfg.pages, key);
  const policyFromHandle = handle => {
    const key = (handle || '').replace(/^lm-copy-/, '');
    return hasPolicy(key) ? key : null;
  };
  function element(tag, text, className) {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  }
  function previewURL(page, values = {}, hash = '') {
    const link = new URL(cfg.rootUrl, location.origin);
    link.searchParams.set('page', page);
    if (/^\d+$/.test(params.get('preview_theme_id') || '')) link.searchParams.set('preview_theme_id', params.get('preview_theme_id'));
    for (const [key, value] of Object.entries(values)) {
      for (const item of Array.isArray(value) ? value : [value]) link.searchParams.append(key, item);
    }
    link.hash = hash;
    return link.href;
  }
  // Preserve an explicitly supplied preview theme when navigating this copy.
  document.querySelectorAll('a[href]').forEach(link => {
    const target = new URL(link.href, location.origin);
    if (target.origin === location.origin && target.searchParams.has('page') && /^\d+$/.test(params.get('preview_theme_id') || '')) {
      target.searchParams.set('preview_theme_id', params.get('preview_theme_id')); link.href = target.href;
    }
  });
  let stored = {crew: [], cart: []}, storageReadable = true;
  function readSaved() {
    try {
      const data = JSON.parse(localStorage.getItem(storageKey) || '{}');
      return {crew: model.validRefs(data?.crew, catalog, true) ? data.crew : [], cart: model.validRefs(data?.cart, catalog, true) ? data.cart : []};
    } catch { storageReadable = false; return {crew: [], cart: []}; }
  }
  stored = readSaved();
  function persist(field, refs) {
    if (!model.validRefs(refs, catalog, true)) return false;
    const latest = readSaved();
    stored = {...latest, [field]: [...refs]};
    try { localStorage.setItem(storageKey, JSON.stringify(stored)); storageReadable = true; syncBag(); return true; }
    catch { storageReadable = false; syncBag(); return false; }
  }
  function syncBag() { const count = serverCart?.item_count || 0; $('cart-count').textContent = String(count); $('cart-count').hidden = !count; }
  syncBag();
  function timer() {
    const clock = model.dailyClock(Date.now());
    $('countdown').textContent = clock.display; $('countdown').dateTime = clock.end;
  }
  timer(); setInterval(timer, 1000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) timer(); });
  $('trust-motion').addEventListener('click', () => {
    const paused = $('trust-motion').getAttribute('aria-pressed') !== 'true';
    $('trust-motion').setAttribute('aria-pressed', String(paused));
    $('trust-motion').setAttribute('aria-label', (paused ? 'Play' : 'Pause') + ' moving shopping information');
    $('trust-motion').textContent = paused ? 'Play' : 'Pause'; $('trust-track').classList.toggle('is-paused', paused);
  });

  let page = params.get('page') || app.dataset.defaultPage;
  if (page === 'page') page = policyFromHandle(app.dataset.pageHandle) || policyFromHandle(app.dataset.pageSuffix) || (app.querySelector('[data-view="native-page"]') ? 'native-page' : 'not-found');
  if (!['home', 'product', 'collection', 'cart', 'search', 'native-page', 'not-found'].includes(page) && !hasPolicy(page)) page = 'not-found';
  let productRef = null;
  if (page === 'product') {
    productRef = params.get('ref') || products.find(product => product.handle === app.dataset.productHandle)?.reference;
    if (!productRef || !Object.prototype.hasOwnProperty.call(catalog, productRef)) page = 'not-found';
  }
  const selectionState = model.initialSelection(location.search, catalog, stored.crew, productRef);
  if (!selectionState.refs && ['home', 'product'].includes(page)) page = 'not-found';
  let selection = selectionState.refs || [products[0].reference, products[0].reference];
  const view = ['home', 'product', 'collection'].includes(page) ? 'builder' : hasPolicy(page) ? 'policy' : page;
  document.querySelectorAll('[data-view]').forEach(node => { node.hidden = node.dataset.view !== view; });
  if (page === 'not-found') document.title = 'Page not found | Lift Mischief';

  function productImage(product, className) {
    const image = element('img', undefined, className);
    image.src = product.image; image.alt = product.imageAlt;
    image.width = 600; image.height = 600; image.loading = 'lazy'; image.decoding = 'async';
    image.addEventListener('error', () => image.replaceWith(element('p', product.name + ' — image unavailable.')));
    return image;
  }
  function card(product, chooseButton = false) {
    const article = element('article', undefined, 'lm-card');
    article.dataset.family = product.family; article.dataset.reference = product.reference;
    const link = element('a'); link.href = previewURL('product', {ref: product.reference});
    link.setAttribute('aria-label', 'View ' + product.name + ' ski mask');
    const frame = element('span', undefined, 'lm-card-photo'); frame.append(productImage(product));
    link.append(frame, element('h3', product.name)); article.append(link);
    if (product.badge) article.append(element('span', product.badge, 'lm-card-badge'));
    article.append(element('p', money(product.unitCents) + ' / mask'), element('p', product.imageCaption, 'reference-evidence'));
    if (chooseButton) {
      const button = element('button', 'Choose ' + product.name); button.type = 'button';
      button.addEventListener('click', () => {
        if (page === 'collection') { location.href = previewURL('home', {face: [product.reference, product.reference]}, 'lm-builder'); return; }
        selection[0] = product.reference; renderBuilder(); scrollToBuilder();
      });
      article.append(button);
    }
    return article;
  }
  const matches = query => products.filter(product => (product.name + ' ' + product.family + ' ' + product.reference).toLowerCase().includes(query.trim().toLowerCase()));
  function searchDialogResults() {
    const results = $('search-results'); results.replaceChildren();
    const found = matches($('mask-search').value);
    for (const product of found) {
      const link = element('a', product.name + ' · ' + product.family);
      link.href = previewURL('product', {ref: product.reference}); results.append(link);
    }
    if (!found.length) results.append(element('p', 'No matching face. Try a design name, yellow, animal, or grin.'));
  }
  const dialog = $('search-dialog');
  document.querySelectorAll('[data-search-open]').forEach(link => link.addEventListener('click', event => {
    if (typeof dialog.showModal !== 'function') return;
    event.preventDefault(); searchDialogResults(); dialog.showModal(); $('mask-search').focus();
  }));
  document.querySelector('[data-search-close]').addEventListener('click', () => dialog.close());
  $('mask-search').addEventListener('input', searchDialogResults);
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  if (page === 'search') {
    document.title = 'Search masks | Lift Mischief';
    $('catalog-search').value = params.get('q') || '';
    const renderSearch = () => {
      const found = matches($('catalog-search').value);
      $('catalog-search-count').textContent = found.length + ' matching designs';
      $('catalog-search-results').replaceChildren(...found.map(product => card(product)));
    };
    $('catalog-search').addEventListener('input', renderSearch); renderSearch();
  }
  if (hasPolicy(page)) {
    const [title, sections] = cfg.pages[page];
    $('policy-title').textContent = title; document.title = title + ' | Lift Mischief';
    for (const [heading, paragraph] of Object.entries(sections)) {
      const section = element('section'); section.append(element('h2', heading), element('p', paragraph)); $('policy-content').append(section);
    }
    $('copy-privacy-controls').hidden = page !== 'privacy'; $('copy-contact-link').hidden = page !== 'contact';
  }
  $('clear-saved-cart').addEventListener('click', () => {
    try { localStorage.removeItem(storageKey); stored = {crew: [], cart: []}; syncBag(); $('privacy-status').textContent = 'Saved crew selections cleared. Use the cart controls to remove cart items. Order records are unchanged.'; }
    catch { $('privacy-status').textContent = 'The browser could not clear storage. Use its site-data controls.'; }
  });

  function scrollToBuilder() { $('lm-builder').scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'}); }
  function buttonText(button, text) {
    let label = button.querySelector('[data-button-label]');
    if (!label) { label = element('span'); label.dataset.buttonLabel = ''; for (const child of [...button.childNodes]) if (child.nodeType === Node.TEXT_NODE) child.remove(); button.prepend(label); }
    label.textContent = text;
  }
  function renderBuilder() {
    const q = model.quote(selection, catalog, cfg.offers);
    const product = catalog[productRef || selection[0]];
    $('mask-heading').textContent = page === 'product' ? product.name + ' Ski Mask' : 'Lift Mischief Masks';
    if (page === 'product') document.title = product.name + ' Ski Mask | Lift Mischief';
    $('selected-name').textContent = product.name; $('family-label').textContent = product.family;
    $('hero-image').src = product.image; $('hero-image').alt = product.imageAlt; $('hero-image').hidden = false; $('hero-placeholder').hidden = true;
    $('photo-name').textContent = product.name; $('image-evidence').textContent = product.imageKind;
    $('reference-detail').textContent = [product.detail, product.material, product.fit].join(' ');
    $('published-reviews').replaceChildren(element('p', 'No customer reviews for ' + product.name + ' yet.'));
    document.querySelectorAll('[data-thumb]').forEach(node => node.setAttribute('aria-pressed', String(node.dataset.thumb === product.reference)));
    document.querySelectorAll('[name="crew-size"]').forEach(radio => { radio.checked = Number(radio.value) === selection.length; });
    document.querySelectorAll('[data-pack-body]').forEach(body => { body.hidden = Number(body.dataset.packBody) !== selection.length; });
    document.querySelector('[data-pack-body="' + selection.length + '"]').append($('face-picker'));
    for (let index = 0; index < 3; index++) {
      const ref = selection[index] || selection[0];
      document.querySelector('[data-slot="' + (index + 1) + '"]').hidden = index >= selection.length;
      $('face-' + (index + 1)).value = ref;
      const image = document.querySelector('[data-slot-image="' + (index + 1) + '"]'); image.src = catalog[ref].image; image.hidden = false;
    }
    for (const count of [1, 2, 3]) {
      const pack = model.quote(Array.from({length: count}, (_,index) => selection[index] || selection[0]), catalog, cfg.offers);
      document.querySelector('[data-pack-price="' + count + '"]').textContent = money(pack.netCents);
      document.querySelector('[data-pack-average="' + count + '"]').textContent = money(Math.round(pack.netCents / count));
      document.querySelector('[data-pack-compare="' + count + '"]').textContent = money(pack.subtotalCents);
      document.querySelector('[data-pack-before="' + count + '"]').hidden = !pack.discountCents;
      document.querySelector('[data-pack-saving="' + count + '"]').textContent = pack.discountCents ? 'Save ' + pack.percent + '%' : 'Individual price';
      document.querySelector('[data-pack-shipping="' + count + '"]').textContent = pack.shippingCents ? money(pack.shippingCents) + ' US shipping' : 'Free US shipping';
    }
    $('builder-count').textContent = q.count + ' mask' + (q.count === 1 ? '' : 's');
    $('builder-total').textContent = money(q.netCents); $('builder-compare').textContent = money(q.subtotalCents);
    $('builder-before').hidden = !q.discountCents; $('builder-sale-label').hidden = !q.discountCents;
    $('builder-sale-label').textContent = 'Save ' + q.percent + '%';
    $('builder-average').textContent = money(Math.round(q.netCents / q.count)) + ' / mask average';
    $('savings').textContent = q.discountCents ? 'Save ' + q.percent + '% vs ' + money(q.subtotalCents) + ' buying the same masks individually.' : 'Single mask · no bundle discount.';
    $('shipping-note').textContent = 'US shipping ' + money(q.shippingCents) + ' · Total before tax ' + money(q.preTaxTotalCents) + ' · Tax calculated at checkout';
    $('sticky-count').textContent = 'Selected: ' + $('builder-count').textContent + ' · ' + [...new Set(selection)].map(ref => catalog[ref].name).join(' + ');
    $('sticky-total').textContent = money(q.netCents) + ' + ' + money(q.shippingCents) + ' shipping';
    $('match-all').hidden = selection.length < 2;
    $('save-crew').disabled = false; $('save-crew').textContent = 'Save this crew';
    $('saved-crew-panel').hidden = false;
    $('draft-context').textContent = storageReadable ? 'Choose your faces. Save your crew for later, or add it to your cart.' : 'Browser storage is unavailable. You can still add these masks to your cart.';
    $('return-saved-crew').hidden = !stored.crew.length;
    $('return-saved-crew').href = previewURL('home', {saved: '1'}, 'lm-builder');
    $('add-to-cart').disabled = cartBusy; $('sticky-add').disabled = cartBusy;
    const cartLabel = cartBusy ? 'Updating cart…' : serverCart?.item_count ? 'Update cart with this crew' : 'Add to cart';
    buttonText($('add-to-cart'), cartLabel); buttonText($('sticky-add'), cartLabel);
  }
  function filter(family) {
    if (!['Featured', 'All', ...families].includes(family)) family = 'All';
    let count = 0;
    $('product-grid').querySelectorAll('.lm-card').forEach(node => {
      const product = catalog[node.dataset.reference];
      node.hidden = !(family === 'All' || (family === 'Featured' ? Boolean(product.badge) : product.family === family));
      if (!node.hidden) count++;
    });
    document.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === family)));
    $('filter-status').textContent = count + ' ' + (family === 'Featured' ? 'featured designs' : family === 'All' ? 'designs' : family.toLowerCase() + ' designs');
  }
  if (view === 'builder') {
    renderBuilder();
    if (page === 'collection') {
      app.classList.add('lm-collection-only');
      $('lm-masks').querySelector('h2').textContent = 'Find your mountain face.';
    }
    const gallery = (productRef ? [catalog[productRef], ...products.filter(product => product.family === catalog[productRef].family && product.reference !== productRef)] : products).slice(0, 5);
    for (const product of gallery) {
      const button = element('button', undefined, 'lm-thumb'); button.type = 'button'; button.dataset.thumb = product.reference;
      button.setAttribute('aria-label', (productRef ? 'View ' : 'Choose ') + product.name + (productRef ? ' ski mask' : ' for mask 1'));
      button.setAttribute('aria-pressed', String(product.reference === (productRef || selection[0])));
      button.append(productImage(product), element('span', product.name));
      button.addEventListener('click', () => {
        if (productRef) { location.href = previewURL('product', {ref: product.reference}); return; }
        selection[0] = product.reference; renderBuilder();
      });
      $('thumbs').append(button);
    }
    if (productRef) $('lm-builder').querySelector('.lm-gallery > .lm-caption').textContent = 'Thumbnails open another product. This photo shows the requested design; use the selectors to choose the masks in your pack.';
    $('hero-image').addEventListener('error', () => { $('hero-image').hidden = true; $('hero-placeholder').hidden = false; $('hero-placeholder').textContent = 'Product image unavailable. No substitute image is shown.'; });
    for (const product of products) $('product-grid').append(card(product, true));
    const collectionLabel = (app.dataset.collectionTitle + ' ' + app.dataset.collectionHandle).toLowerCase();
    const collectionFamily = families.find(family => collectionLabel.includes(family.toLowerCase()) || collectionLabel.includes(family.toLowerCase().replaceAll(' ', '-')));
    filter(params.get('family') || (page === 'collection' ? collectionFamily || 'All' : 'Featured'));
    document.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => filter(button.dataset.filter)));
    if (page === 'home') document.querySelectorAll('.lm-family-nav a').forEach(link => link.addEventListener('click', event => {
      const family = new URL(link.href).searchParams.get('family'); if (!family) return;
      event.preventDefault(); filter(family); $('lm-masks').scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }));
    document.querySelectorAll('[name="crew-size"]').forEach(radio => radio.addEventListener('change', () => { selection = Array.from({length: Number(radio.value)}, (_,index) => selection[index] || selection[0]); renderBuilder(); }));
    [1, 2, 3].forEach(index => $('face-' + index).addEventListener('change', event => { selection[index - 1] = event.target.value; renderBuilder(); }));
    $('match-all').addEventListener('click', () => { selection = selection.map(() => selection[0]); renderBuilder(); });
    $('save-crew').addEventListener('click', () => {
      const saved = persist('crew', selection); renderBuilder();
      $('draft-context').textContent = saved ? 'Crew saved in this browser. Your cart is unchanged.' : 'Could not save in this browser. You can still add your crew to the cart.';
    });
    const addCrew = async () => {
      if (cartBusy) return;
      const refs = [...selection]; cartBusy = true; renderBuilder();
      $('builder-status').textContent = 'Checking your exact designs and updating your cart…';
      try {
        serverCart = await commerce.setCrew(refs); syncBag();
        const result = commerce.validate(serverCart);
        if (!result.ok) throw new Error(result.reason);
        persist('crew', refs); location.href = previewURL('cart');
      } catch(error) {
        $('builder-status').textContent = error.message;
        // Read only after failure; never automatically repeat an uncertain write.
        try { serverCart = await commerce.get(); syncBag(); } catch {}
      } finally { cartBusy = false; renderBuilder(); }
    };
    $('add-to-cart').addEventListener('click', addCrew); $('sticky-add').addEventListener('click', addCrew);
    $('share-crew').addEventListener('click', () => {
      const output = $('share-crew-url'); output.value = previewURL('home', {face: selection}, 'lm-builder'); output.hidden = false;
      output.focus(); output.select();
      $('share-crew-status').textContent = 'Copy this link to share these exact masks with your crew.';
    });
    const sticky = () => { $('sticky-cart').hidden = page === 'collection' || $('add-to-cart').getBoundingClientRect().bottom > 0; };
    window.addEventListener('scroll', sticky, {passive: true}); window.addEventListener('resize', sticky); sticky();
  }

  function renderCart() {
    const content = $('cart-content'); content.replaceChildren(); syncBag();
    $('checkout-actions').hidden = true;
    if (!serverCart) { content.append(element('p', 'Loading your cart…')); return; }
    const verified = commerce.validate(serverCart), refs = verified.refs || [];
    $('edit-preview-bag').href = refs.length && refs.length <= 3 ? previewURL('home', {face:refs}, 'lm-builder') : previewURL('home');
    if (!serverCart.item_count) { content.append(element('p', 'Your cart is empty. Choose your faces to build your crew.')); return; }
    const savings = serverCart.original_total_price - serverCart.total_price;
    const deal = element('div', undefined, 'lm-cart-deal'); deal.append(element('small', 'Your mask pack'));
    if (savings) deal.append(element('del', money(serverCart.original_total_price)));
    deal.append(element('strong', money(serverCart.total_price)), element('p', savings ? 'Bundle savings applied automatically.' : 'Single mask price.'));
    content.append(deal);
    for (const line of serverCart.items) {
      const product = commerce.bySku[line.sku];
      const row = element('div', undefined, 'cart-line'), detail = element('div', undefined, 'cart-product-detail');
      detail.append(element('strong', (product?.name || line.product_title) + ' × ' + line.quantity), element('small', product?.family || 'Other item'));
      const controls = element('div', undefined, 'cart-quantity');
      const update = async quantity => {
        if (cartBusy) return; cartBusy = true; renderCart();
        $('cart-status').textContent = 'Updating your cart…';
        try { serverCart = await commerce.change(line.key, quantity); $('cart-status').textContent = 'Cart updated.'; }
        catch(error) { $('cart-status').textContent = error.message; try {serverCart = await commerce.get();} catch {} }
        finally {cartBusy = false; renderCart();}
      };
      for (const [label, text, action, disabled] of [
        ['Decrease ' + line.product_title, '−', () => update(line.quantity - 1), false],
        ['Increase ' + line.product_title, '+', () => update(line.quantity + 1), serverCart.item_count >= 3],
        ['Remove ' + line.product_title, 'Remove', () => update(0), false]
      ]) {
        const button = element('button', text); button.type = 'button'; button.setAttribute('aria-label', label); button.disabled = disabled || cartBusy; button.addEventListener('click', action); controls.append(button);
      }
      detail.append(controls); if (product) row.append(productImage(product, 'cart-product-image'));
      row.append(detail, element('strong', money(line.final_line_price))); content.append(row);
    }
    if (!verified.ok) { content.append(element('p', verified.reason, 'lm-hint')); return; }
    const totals = element('dl', undefined, 'totals');
    for (const [label, value] of [['Buying separately', money(serverCart.original_total_price)], ['Bundle savings', '−' + money(savings)], ['US shipping', money(verified.shippingCents)], ['Tax', 'Calculated at checkout'], ['Total before tax', money(serverCart.total_price + verified.shippingCents)]]) {
      const row = element('div'); row.append(element('dt', label), element('dd', value)); totals.append(row);
    }
    content.append(totals);
    $('checkout-actions').hidden = false; $('checkout-button').disabled = cartBusy;
  }
  if (page === 'cart') { document.title = 'Your crew | Lift Mischief'; renderCart(); }
  async function refreshCart() {
    try {serverCart = await commerce.get(); syncBag(); if (page === 'cart') renderCart(); else if (view === 'builder') renderBuilder();}
    catch(error) {if (page === 'cart') {$('cart-content').textContent = 'Unable to load your cart. Refresh this page to try again.'; $('cart-status').textContent = error.message;}}
  }
  refreshCart();
  $('checkout-form').addEventListener('submit', async event => {
    event.preventDefault(); if (cartBusy) return;
    cartBusy = true; $('checkout-button').disabled = true; $('cart-status').textContent = 'Checking your cart before secure checkout…';
    try {
      serverCart = await commerce.get(); const verified = commerce.validate(serverCart);
      if (!verified.ok) throw new Error(verified.reason);
      // Shopify performs address, tax, payment and final availability validation.
      location.href = cfg.rootUrl + 'checkout';
    } catch(error) {$('cart-status').textContent = error.message; cartBusy = false; renderCart();}
  });
  window.addEventListener('storage', event => {
    if (event.key !== storageKey && event.key !== null) return;
    stored = readSaved(); refreshCart();
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    stored = readSaved(); refreshCart();
  });
  if (location.hash && view === 'builder') requestAnimationFrame(() => document.getElementById(location.hash.slice(1))?.scrollIntoView());
})();
